import React, { useState } from "react";

const Pagination = ({
  totalItems,
  itemsPerPage,
  onPageChange,
  className = "",
  currentPage,
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  // const handlePageChange = (page) => {
  //   setCurrentPage(page);
  //   onPageChange(page);
  // };

  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  // const handleNextPrevChange = (direction) => {
  //   let newPage;
  //   if (direction === "next" && currentPage < totalPages) {
  //     newPage = currentPage + 1;
  //   } else if (direction === "prev" && currentPage > 1) {
  //     newPage = currentPage - 1;
  //   } else {
  //     return;
  //   }

  //   setCurrentPage(newPage);
  //   onPageChange(newPage);
  // };

  const renderPageButtons = () => {
    let pages = [];

    if (totalPages <= 5) {
      // Show all pages if there are 5 or fewer pages
      for (let i = 1; i <= totalPages; i++) {
        pages.push(
          <button
            key={i}
            onClick={() => handlePageClick(i)}
            className={`px-[9px] py-[8px] rounded-[8px] w-[30px] h-[30px] ${
              i === currentPage
                ? "bg-blue-shades text-white font-medium font-roboto text-level-5 leading-[14.63px]"
                : "bg-soft-gray text-blue-shades font-medium font-roboto text-level-5 leading-[14.63px]"
            }`}
          >
            {i}
          </button>
        );
      }
    } else {
      // Display pagination with ellipsis as described
      const startPage = Math.max(2, currentPage - 1);
      const endPage = Math.min(totalPages - 1, currentPage + 1);

      // First page
      pages.push(
        <button
          key={1}
          onClick={() => handlePageClick(1)}
          className={`px-[9px] py-[8px] rounded-[8px] w-[30px] h-[30px] ${
            1 === currentPage
              ? "bg-blue-shades text-white font-medium font-roboto text-level-5 leading-[14.63px]"
              : "bg-soft-gray text-blue-shades font-medium font-roboto text-level-5 leading-[14.63px]"
          }`}
        >
          1
        </button>
      );

      // Ellipsis if current page is beyond the initial range
      if (currentPage > 3) {
        pages.push(
          <span key="start-ellipsis" className="px-2">
            ...
          </span>
        );
      }

      // Middle pages
      for (let i = startPage; i <= endPage; i++) {
        pages.push(
          <button
            key={i}
            onClick={() => handlePageClick(i)}
            className={`px-[9px] py-[8px] rounded-[8px] w-[30px] h-[30px] ${
              i === currentPage
                ? "bg-blue-shades text-white font-medium font-roboto text-level-5 leading-[14.63px]"
                : "bg-soft-gray text-blue-shades font-medium font-roboto text-level-5 leading-[14.63px]"
            }`}
          >
            {i}
          </button>
        );
      }

      // Ellipsis if there are more pages after the current range
      if (currentPage < totalPages - 2) {
        pages.push(
          <span key="end-ellipsis" className="px-2">
            ...
          </span>
        );
      }

      // Last page
      pages.push(
        <button
          key={totalPages}
          onClick={() => handlePageClick(totalPages)}
          className={`px-[9px] py-[8px] rounded-[8px] w-[30px] h-[30px] ${
            totalPages === currentPage
              ? "bg-blue-shades text-white font-medium font-roboto text-level-5 leading-[14.63px]"
              : "bg-soft-gray text-blue-shades font-medium font-roboto text-level-5 leading-[14.63px]"
          }`}
        >
          {totalPages}
        </button>
      );
    }

    return pages;
  };

  return (
    <div className={`flex items-center space-x-[12px] ${className}`}>
      <button
        onClick={() => handlePageClick(currentPage - 1)}
        disabled={currentPage === 1}
        className={` py-2 rounded-full text-gray font-inter font-medium text-level-4 leading-[14.52px] ${
          currentPage === 1 ? "cursor-not-allowed" : "cursor-pointer"
        }`}
      >
        Previous
      </button>

      {renderPageButtons()}

      <button
        onClick={() => handlePageClick(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`py-2 rounded-full text-gray font-inter font-medium text-level-4 leading-[14.52px] ${
          currentPage === totalPages ? "cursor-not-allowed" : "cursor-pointer"
        }`}
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;
